import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { List } from 'antd';
import { formViewSelector } from '@store/policies/schedule/selectors';
import { actOptions, policyAction } from '@store/policies/schedule/utils';
import { StyledPopover } from './styled';

function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function useValidateForm() {
  const { policies, activationState, triggerAt, emailIds, modalType } =
    useSelector(formViewSelector);

  const [canSubmit, setCanSubmit] = useState(true);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const err: any = {};

    //  policy check
    if (modalType === policyAction.activate && policies.length === 0) {
      err.policies = 'At least one policy is required.';
    }

    // additional fields to validate for schedule
    if (activationState === actOptions.schedule) {
      // time
      if (!moment(triggerAt).isValid()) {
        err.triggerAt = 'Invalid trigger time.';
      }

      // emails
      if (isEmpty(emailIds)) {
        err.emailIds = 'At least one email-id is required.';
      } else {
        const invalidEmails = emailIds.filter((m) => !validateEmail(m)).join(',');
        if (invalidEmails) {
          err.emailIds = `Invalid email-ids: ${invalidEmails}`;
        }
      }
    }

    setCanSubmit(Object.keys(err).length === 0);
    setErrors(err);
  }, [policies, activationState, triggerAt, emailIds]);

  return { canSubmit, errors };
}

const renderItem = (item: any) => <List.Item>{item}</List.Item>;

const generateErrorSummary = (errors) =>
  errors ? (
    <List
      header={<h3>Please resolve the below errors to submit the form</h3>}
      dataSource={Object.values(errors)}
      renderItem={renderItem}
    />
  ) : null;

export const Validator = ({ deleteMode = false, children }) => {
  const { canSubmit, errors } = useValidateForm();
  const enableSaveBtn = canSubmit || deleteMode;
  const btn = children(enableSaveBtn);

  return enableSaveBtn ? (
    <>{btn}</>
  ) : (
    <StyledPopover placement="right" content={generateErrorSummary(errors)}>
      {btn}
    </StyledPopover>
  );
};
